const mitigationOptionItems = {
  bannerType: {
    EXACT_DISPLAY_NAME_IMPERSONATION: {
      value: 2,
      label: 'Exact Display Name Impersonation',
    },
    DOMAIN_LOOK_ALIKE: { value: 4, label: 'Domain Look-Alike' },
    FIRST_TIME_SENDER: { value: 5, label: 'First Time Sender' },
    SIMILAR_DISPLAY_NAME_IMPERSONATION: {
      value: 6,
      label: 'Similar Display Name Impersonation',
    },
    COMPANY_DOMAIN_DISPLAY_NAME: {
      value: 8,
      label: "Company's Name Appears in Display Name",
    },
    SENDER_ADDRESS_SPOOFING: { value: 10, label: 'Sender Address Spoofing' },
    INTERNAL_ADDRESS_DISPLAY_NAME: {
      value: 11,
      label: 'Known Address in Display Name',
    },
    DOMAIN_IN_SENDER_LOCAL_PART: {
      value: 17,
      label: 'Sender Address Contains Domain Look-alike',
    },
  },
  incidentType: {
    ADD_ON: { value: 0, label: 'Report Phishing Button' },
    NINE_ONE_ONE: { value: 1, label: '911' },
    COMMUNITY: { value: 2, label: 'Community' },
    MALICIOUS_LINKS: { value: 3, label: 'Malicious Links' },
    COMPUTER_VISION: { value: 4, label: 'Computer Vision' },
    MALICIOUS_ATTACHMENTS: { value: 5, label: 'Malicious Attachments' },
    MAILBOX_ANOMALY: { value: 6, label: 'Mailbox Anomaly' },
    CREDENTIAL_THEFT: { value: 7, label: 'Credential Theft' },
  },
  resolvedBy: {
    THEMIS_PHISHING: { value: 0, label: 'Themis - Phishing' },
    THEMIS_SPAM: { value: 1, label: 'Themis - Spam' },
    AUTOMATED_THREAT_DETECTION: { value: 2, label: 'Automated Threat Detection - Spam' },
    COMPUTER_VISION: { value: 3, label: 'Computer Vision - Phishing' },
    MALWARE_AND_URL_PROTECTION: {
      value: 4,
      label: 'Malware & URL Protection - Phishing',
    },
    ANALYST_PHISHING: { value: 5, label: 'Analyst - Phishing' },
    ANALYST_SPAM: { value: 6, label: 'Analyst - Spam' },
    ANALYST_FALSE_POSITIVE: { value: 7, label: 'Analyst - Safe' },
    UNCLASSIFIED: { value: 8, label: 'Unclassified' },
  },
  reportedBy: {
    COMMUNITY: { value: 0, label: 'IRONSCALES Community' },
    IMPERSONATION_PROTECTION: { value: 1, label: 'Impersonation Protection' },
    END_USER: { value: 2, label: 'End User' },
    MALWARE_AND_URL_PROTECTION: { value: 3, label: 'Malware & URL Protection' },
    AUTOMATED_THREAT_DETECTION: { value: 4, label: 'Automated Threat Detection' },
    SOC_ANALYST: { value: 5, label: 'SOC Analyst' },
  },
  resolutionType: {
    PHISHING: { value: 1, label: 'Phishing' },
    SPAM: { value: 2, label: 'Spam' },
    FP: { value: 3, label: 'Safe' },
  },
}

const mitigationFilterOptions = {
  bannerType: [
    mitigationOptionItems.bannerType.EXACT_DISPLAY_NAME_IMPERSONATION,
    mitigationOptionItems.bannerType.DOMAIN_LOOK_ALIKE,
    mitigationOptionItems.bannerType.FIRST_TIME_SENDER,
    mitigationOptionItems.bannerType.SIMILAR_DISPLAY_NAME_IMPERSONATION,
    mitigationOptionItems.bannerType.COMPANY_DOMAIN_DISPLAY_NAME,
    mitigationOptionItems.bannerType.SENDER_ADDRESS_SPOOFING,
    mitigationOptionItems.bannerType.INTERNAL_ADDRESS_DISPLAY_NAME,
    mitigationOptionItems.bannerType.DOMAIN_IN_SENDER_LOCAL_PART,
  ],
  incidentType: [
    mitigationOptionItems.incidentType.ADD_ON,
    mitigationOptionItems.incidentType.NINE_ONE_ONE,
    mitigationOptionItems.incidentType.COMMUNITY,
    mitigationOptionItems.incidentType.MALICIOUS_LINKS,
    mitigationOptionItems.incidentType.COMPUTER_VISION,
    mitigationOptionItems.incidentType.MALICIOUS_ATTACHMENTS,
    mitigationOptionItems.incidentType.MAILBOX_ANOMALY,
  ],
  resolvedBy: [
    mitigationOptionItems.resolvedBy.THEMIS_PHISHING,
    mitigationOptionItems.resolvedBy.THEMIS_SPAM,
    mitigationOptionItems.resolvedBy.COMPUTER_VISION,
    mitigationOptionItems.resolvedBy.MALWARE_AND_URL_PROTECTION,
    mitigationOptionItems.resolvedBy.ANALYST_PHISHING,
    mitigationOptionItems.resolvedBy.ANALYST_SPAM,
    mitigationOptionItems.resolvedBy.ANALYST_FALSE_POSITIVE,
    mitigationOptionItems.resolvedBy.UNCLASSIFIED,
  ],
  reportedBy: [
    mitigationOptionItems.reportedBy.COMMUNITY,
    mitigationOptionItems.reportedBy.MALWARE_AND_URL_PROTECTION,
    mitigationOptionItems.reportedBy.AI_POWERED_INCIDENT_RESPONSE,
    mitigationOptionItems.reportedBy.IMPERSONATION_PROTECTION,
  ],
  resolutionType: [
    mitigationOptionItems.resolutionType.PHISHING,
    mitigationOptionItems.resolutionType.SPAM,
    mitigationOptionItems.resolutionType.FP,
  ],
}

const LIST_TYPE = {
  INCIDENTS: 1,
  BANNERS: 2,
}

const NAME_FOR_HISTORY_STORE = 'tpList'

export const CUSTOM_MAX_RANGE = 730

export { mitigationOptionItems, mitigationFilterOptions, LIST_TYPE, NAME_FOR_HISTORY_STORE }
